import React from "react";
import './NewsLetter.css'
import icon from '../../../assets/images/forthfirst2.webp'





export default function NewsLetter(){

    return(
        <div className="newsletter__container main">
          <div className="newsletter__left">
              <div className="newsletter__heading">
                <p>Interested in an Evaluation Account?</p>
                <p>Submit your email for a chance to win one of four $50,000 challenge accounts every month!</p>  
              </div>
              <div className="newsletter__inputs">
                <p>Email address</p>
                <input type="email" class="form-control" name="email" placeholder="Your Email"/>
                <button type="submit" name="newsletter_submit">Continue</button>
              </div>
          </div>
          <div className="newsletter__right">
             <img src={icon}      loading='lazy'/>
          </div>
        </div>
    )
}